<template>
    <div>

    <main class="py-12 space-y-12">
            <section>
              <div class="blog-posts container space-y-8">
                <h1>Blog</h1>
                <div class="grid grid-cols-3 gap-12">
                  <BlogTeaserCard
                      v-for="(post) in postData"
                      :key="post.documentId"
                      v-bind="post"
                  />
                </div>
                </div>
            </section>

            <section>
                <div class="container">
                    <Pagination
                        v-model:page="page"
                        :last-page="lastPage"
                        @update:page="setPage('pagination');"
                    />
                </div>
            </section>
        </main>
    </div>
</template>

<script setup lang="ts">
import {ALL_BLOG_POSTS} from '~~/graphql/queries/findAllBlogPosts';
import {BLOG_POSTS} from '~~/graphql/queries/findBlogPosts';

definePageMeta({
    path: '/Blog',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Neuigkeiten',
};

const graphql = useStrapiGraphQL();

const res = await graphql(ALL_BLOG_POSTS);
const allPosts = res?.data?.blogPosts || [];

const postsPerPage = ref(12);
const postData = ref<any[]>([]);
const page = ref(1);
const lastPage = ref(Math.ceil(allPosts.length / postsPerPage.value));

async function getPosts() {
    const response = await graphql(BLOG_POSTS, {pagination: page.value, perPage: postsPerPage.value});
    postData.value = response?.data?.blogPosts || [];
}

function setPage(type: string) {
    if (type === 'pagination') {
        getPosts();
    }
}

getPosts();
</script>

<style scoped>
.blog-posts {
    .blog-header {
        & > div {
            @apply duration-300 hover:scale-105;
        }
    }
}
</style>
